import { useEffect } from 'react'
import { Block, Link, useWizard } from '@mote/ui'
import { useOnboarding } from '../context'
import type { ConsentOnChangeKey } from './Consent'
import { Consent } from './Consent'
import { WizardControls } from './wizard'

export interface SurveySubmitProps {
  onSubmit: () => void
  isLoading: boolean
}

export const SurveySubmit = (props: SurveySubmitProps) => {
  const { state, updateState, isValidState, getConsentStatus } = useOnboarding()
  const { setIsNextDisabled } = useWizard()

  function handleConsentAccept(key: ConsentOnChangeKey, accepted: boolean) {
    if (key === 'newsletter') {
      updateState({ newsletterConsent: accepted })
      return
    }

    const [consentKey, consentReverseKey] = state.survey.is_minor?.value
      ? ['hasAdultPermission', 'acceptedTerms']
      : ['acceptedTerms', 'hasAdultPermission']

    updateState({ [consentKey]: accepted, [consentReverseKey]: false })
  }

  useEffect(() => {
    setIsNextDisabled(!isValidState())
  }, [state])

  function getConsentLabel() {
    if (state.survey.is_minor?.value) {
      return (
        <span data-testid={'submit-survey-consent'}>
          I have permission from a teacher or a supervising adult to use Mote
        </span>
      )
    }

    return (
      <span data-testid={'submit-survey-consent'}>
        {'I have read and agree to the '}
        <Link
          to='/privacy'
          color='inherit'
          fontSize='inherit'
          lineHeight='inherit'
          fontWeight='inherit'
          target='_blank'
          underline='always'
          isExternal
        >
          {'Terms and Conditions '}
        </Link>
        {'and '}
        <Link
          to='/privacy'
          color='inherit'
          fontSize='inherit'
          lineHeight='inherit'
          fontWeight='inherit'
          target='_blank'
          underline='always'
          isExternal
        >
          Privacy Policy
        </Link>
      </span>
    )
  }

  return (
    <Block gap={40} spreadX>
      <Consent
        label={getConsentLabel()}
        onChange={handleConsentAccept}
        checked={getConsentStatus()}
      />
      <WizardControls.FinishButton
        onClick={props.onSubmit}
        isLoading={props.isLoading}
      />
    </Block>
  )
}
